export enum Language {
  en = 'en',
  ro = 'ro',
  ru = 'ru',
  pt = 'pt',
  it = 'it',
  fr = 'fr',
  es = 'es',
}

export function getLanguageFromLocale(localeId: string): Language {
  return localeId.split('-')[0] as Language;
}
